/**
 * Quick add to cart component Message
 *
 * @module quick-view-message
 * @version 1.0.0
 * @extends HTMLElement
 */

class quickViewMessage extends HTMLElement {
  /**
   * Quick View Message component
   *
   * @constructor
   */
  constructor() {
    super();
    this.initEvents();
  }
  /**
   * Inicialize the Trigger quick-add-to-cart event
   * @returns {undefined}
   */
  initEvents() {
    window.addEventListener('quick-add-to-cart', (e) => {
      this.activeTheButtonMessage();
    });
  }
  /**
   * Active The Button Item added Message
   *
   * @returns {undefined}
   */
  activeTheButtonMessage() {
    const message = document.querySelector('.quick-view-message');
    if (message) {
      message.classList.remove('hidden');
      this.scrollTop(message);
    }
  }

  /**
   * Disable The Button Item added Message
   *
   * @returns {undefined}
   */
  disableTheButtonMessage(message) {
    if (message) {
      message.classList.add('hidden');
    }
  }

  /**
   * Scroll Top to the page
   *
   * @returns {undefined}
   */
  scrollTop(message) {
    if (message) {
      let interval = setTimeout(() => {
        this.disableTheButtonMessage(message);
      }, 3000);

      message.addEventListener('click', (e) => {
        clearTimeout(interval);
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // For Safari
        document.body.scrollTop = 0;
        // For Chrome, Firefox, IE and Opera
        document.documentElement.scrollTop = 0;

        this.disableTheButtonMessage(message);
      });
    }
  }
}

customElements.define('quick-view-message', quickViewMessage);
